import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Initial state
const initialState = {
  bookmarks: [],
  loading: false,
  error: null,
};

// Async thunks
export const fetchBookmarks = createAsyncThunk(
  'bookmarks/fetchBookmarks',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/bookmarks');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addBookmark = createAsyncThunk(
  'bookmarks/addBookmark',
  async (paperId, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/bookmarks', { paperId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeBookmark = createAsyncThunk(
  'bookmarks/removeBookmark',
  async (bookmarkId, { rejectWithValue }) => {
    try {
      await axios.delete(`/api/bookmarks/${bookmarkId}`);
      return bookmarkId;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Slice
const bookmarkSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    clearBookmarks: (state) => {
      state.bookmarks = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch bookmarks
      .addCase(fetchBookmarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookmarks.fulfilled, (state, action) => {
        state.bookmarks = action.payload;
        state.loading = false;
      })
      .addCase(fetchBookmarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch bookmarks';
      })
      
      // Add bookmark
      .addCase(addBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBookmark.fulfilled, (state, action) => {
        state.bookmarks.push(action.payload);
        state.loading = false;
      })
      .addCase(addBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to add bookmark';
      })
      
      // Remove bookmark
      .addCase(removeBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeBookmark.fulfilled, (state, action) => {
        state.bookmarks = state.bookmarks.filter(
          (bookmark) => bookmark.id !== action.payload
        );
        state.loading = false;
      })
      .addCase(removeBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to remove bookmark';
      });
  },
});

export const { clearBookmarks } = bookmarkSlice.actions;

export default bookmarkSlice.reducer; 